import React from 'react'
import { Label, Paragraph } from '@entur/typography'
import { ClosedLockIcon } from '@entur/icons'
import { Tooltip } from '@entur/tooltip'
import { space } from '@entur/tokens'
import { FormFieldTypes } from '../../utils/form-utils'

type EmployeeCard = {
  displayLabel?: boolean
  field: FormFieldTypes
}

export const SensitiveInfo: React.FC<EmployeeCard> = ({ field, displayLabel = true }) => {
  return (
    <Tooltip content="Ikke tilgang til sensitiv data" placement="top">
      <span>
        {displayLabel && <Label>{field.displayName}</Label>}
        <Paragraph data-cy="sensitive-info-denied" className="sensitive-info-denied" style={{ marginBottom: 0 }}>
          Ikke tilgang
          <ClosedLockIcon style={{ marginLeft: space.extraSmall }} />
        </Paragraph>
      </span>
    </Tooltip>
  )
}
